import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import { FORM_NAMES, URL_PATHS } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import {
  CardBody,
  Col,
  Container,
  Modal,
  Nav,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap"
import { FormSection, initialize, reduxForm } from "redux-form"
import {
  getExperiencesFeatures,
  getLandingScreenFeatures,
  getVendorConfig,
  getVendorEmailConfig,
  getVendorPaymentConfig,
  resetClientSettingsForm,
} from "store/actions"
import {
  mapApiToEmailSettings,
  mapApiToPaymentSettings,
  mapApiToSettingsForm,
} from "../utils"
import EmailSettingsTab from "./emailSettingsTab"
import ExperiencesTab from "./experiencesTab"
import LandingScreenTab from "./landingScreenTab"
import PaymentSettingsTab from "./paymentSettingsTab"
import SettingsTab from "./settingsTab"

const ClientFeatures = ({
  vendorConfig,
  vendorEmailConfig,
  getVendorConfig,
  getVendorEmailConfig,
  match,
  getLandingScreenFeatures,
  getExperiencesFeatures,
  experiencesFeatures,
  landingScreenFeatures,
  loading,
  initializeForm,
  resetClientSettingsForm,
  getVendorPaymentConfig,
  vendorPaymentConfig,
}) => {
  useEffect(() => {
    getVendorConfig({ id: match?.params?.id })
    getVendorEmailConfig({ id: match?.params?.id })
    getExperiencesFeatures({ id: match?.params?.id, values: { type: 1 } })
    getLandingScreenFeatures({ id: match?.params?.id, values: { type: 0 } })
    // getVendorPaymentConfig({ id: match?.params?.id })
    return () => {
      resetClientSettingsForm()
    }
  }, [])

  useEffect(() => {
    if (
      vendorConfig &&
      vendorEmailConfig &&
      experiencesFeatures &&
      landingScreenFeatures
      // && vendorPaymentConfig
    ) {
      initializeForm({
        experiences_setup: Object.assign(
          {},
          ...experiencesFeatures.map(feature => ({
            [feature.machine_name]: feature.status,
          }))
        ),
        landing_screen_setup: Object.assign(
          {},
          ...landingScreenFeatures.map(feature => ({
            [feature.machine_name]: feature.status,
          }))
        ),
        settings_setup: mapApiToSettingsForm(vendorConfig),
        emailSettings_setup: mapApiToEmailSettings({
          ...vendorConfig,
          ...vendorEmailConfig,
        }),
        // paymentSettings_setup: mapApiToPaymentSettings(vendorPaymentConfig),
      })
    }
  }, [
    vendorConfig,
    vendorEmailConfig,
    experiencesFeatures,
    landingScreenFeatures,
    // vendorPaymentConfig,
  ])

  const TABS = {
    EXPERIENCES: 1,
    LANDING_SCREEN: 2,
    SETTINGS: 3,
    EMAIL_RSVP_SETTINGS: 4,
    PAYMENT_SETTINGS: 5,
  }
  const [activeTab, setActiveTab] = useState(TABS.EXPERIENCES)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  const renderBreadcrumbTitle = () => {
    switch (activeTab) {
      case 1:
        return "Experiences"
      case 2:
        return "Landing Screen"
      case 3:
        return "Settings"
      case 4:
        return "Email & RSVP Settings"
      case 5:
        return "Payment Settings"
      default:
        return ""
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Settings" />
        <Container fluid>
          <Row>
            <Col>
              <BreadcrumbTitle
                title="Settings"
                breadcrumbItems={[
                  { title: "Dashboard" },
                  { title: "Client List", link: "/vendors" },
                  {
                    title: "Client Settings",
                    type: "tab",
                    clickHandler: () => {
                      setActiveTab(TABS.EXPERIENCES)
                    },
                  },
                  {
                    title: renderBreadcrumbTitle(),
                  },
                ]}
              />
            </Col>
          </Row>
          <Row className="d-flex justify-content-end">
            <Col xs="auto" className={"mb-3"}>
              <Link to={URL_PATHS.CLIENTS}>
                <SaveButton content="Back" fullWidth={true} color="light" />
              </Link>
            </Col>
          </Row>
          <Row>
            <Col>
              <form>
                <Nav pills tabs>
                  <NavLink
                    className={markIfIsActive(TABS.EXPERIENCES)}
                    onClick={() => {
                      setActiveTab(TABS.EXPERIENCES)
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>Experiences</span>
                  </NavLink>
                  <NavLink
                    className={markIfIsActive(TABS.LANDING_SCREEN)}
                    onClick={() => {
                      setActiveTab(TABS.LANDING_SCREEN)
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>Landing Screen</span>
                  </NavLink>
                  <NavLink
                    className={markIfIsActive(TABS.SETTINGS)}
                    onClick={() => {
                      setActiveTab(TABS.SETTINGS)
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>Settings</span>
                  </NavLink>
                  <NavLink
                    className={markIfIsActive(TABS.EMAIL_RSVP_SETTINGS)}
                    onClick={() => {
                      setActiveTab(TABS.EMAIL_RSVP_SETTINGS)
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>
                      Email & RSVP Settings
                    </span>
                  </NavLink>
                  {/* <NavLink
                    className={markIfIsActive(TABS.PAYMENT_SETTINGS)}
                    onClick={() => {
                      setActiveTab(TABS.PAYMENT_SETTINGS)
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>Payment Settings</span>
                  </NavLink> */}
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={TABS.EXPERIENCES}>
                    <FormSection name="experiences_setup">
                      <ExperiencesTab vendorId={match?.params?.id} />
                    </FormSection>
                  </TabPane>
                  <TabPane tabId={TABS.LANDING_SCREEN}>
                    <FormSection name="landing_screen_setup">
                      <LandingScreenTab vendorId={match?.params?.id} />
                    </FormSection>
                  </TabPane>
                  <TabPane tabId={TABS.SETTINGS}>
                    <FormSection name="settings_setup">
                      <SettingsTab vendorId={match?.params?.id} />
                    </FormSection>
                  </TabPane>
                  <TabPane tabId={TABS.EMAIL_RSVP_SETTINGS}>
                    <FormSection name="emailSettings_setup">
                      <EmailSettingsTab vendorId={match?.params?.id} />
                    </FormSection>
                  </TabPane>
                  {/* <TabPane tabId={TABS.PAYMENT_SETTINGS}>
                    <FormSection name="paymentSettings_setup">
                      <PaymentSettingsTab vendorId={match?.params?.id} />
                    </FormSection>
                  </TabPane> */}
                </TabContent>
              </form>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal isOpen={loading} centered={true} size="sm">
        <h4 style={{ textAlign: "center" }}>Loading...</h4>
        <CardBody className={"p-2 my-1 text-center"}>
          <Spinner className="ms-2" color="primary" />
        </CardBody>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  vendorConfig: state.clients.vendorConfig,
  vendorEmailConfig: state.clients.vendorEmailConfig,
  experiencesFeatures: state.clients.experiencesFeatures,
  landingScreenFeatures: state.clients.landingScreenFeatures,
  loading: state.clients.loading,
  vendorPaymentConfig: state.clients.vendorPaymentConfig,
})

const mapDispatchToProps = dispatch => ({
  getVendorConfig: values => dispatch(getVendorConfig(values)),
  getVendorEmailConfig: values => dispatch(getVendorEmailConfig(values)),
  getLandingScreenFeatures: values =>
    dispatch(getLandingScreenFeatures(values)),
  getExperiencesFeatures: values => dispatch(getExperiencesFeatures(values)),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.VENDOR_FEATURES, values)),
  resetClientSettingsForm: () => dispatch(resetClientSettingsForm()),
  getVendorPaymentConfig: values => dispatch(getVendorPaymentConfig(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.VENDOR_FEATURES })(ClientFeatures))
